import { lazy } from "react";

export const Home = lazy(() => import("../components/home"));

export const Dashboard = lazy(() =>
  import("../views/dashboard/ForYouPage").then((m) => ({ default: m.ForYouPage })),
);

export const Apps = lazy(() => import("../components/apps"));

export const Account = lazy(() => import("../views/account/account"));

export const InstancesParent = lazy(
  () => import("../views/settings/instances/instances-parent/instancesParent"),
);

export const InstanceHistory = lazy(
  () => import("../views/settings/instances/instanceHistory/instanceHistory"),
);

export const InstancesDetails = lazy(
  () => import("../views/settings/instances/instancesDetails/instancesDetails"),
);

export const InstanceBackup = lazy(
  () => import("../views/settings/instances/instanceBackup/instanceBackup"),
);

export const TenantsSettings = lazy(() => import("../views/settings/tenants/tenants"));

export const CreateTenant = lazy(
  () => import("../views/settings/tenants/createTenant/createTenant"),
);

export const LogsPage = lazy(() => import("../views/settings/logs/LogsPage"));

export const RoleManagementPage = lazy(() => import("../views/settings/roles/RoleManagementPage"));
export const UsersAccessPage = lazy(() => import("../views/users/UsersAccessPage"));

export { default as ErrorPage } from "../components/shared/errorpage";

// General Settings page removed — theme toggle moved to profile menu
// export const GeneralSettingsPage = lazy(() =>
//   import("../views/settings/general/GeneralSettingsPage").then((module) => ({
//     default: module.GeneralSettingsPage,
//   })),
// );

export const EmailSettingsPage = lazy(() =>
  import("../views/settings/email/EmailSettingsPage").then((module) => ({
    default: module.EmailSettingsPage,
  })),
);

export const AppPreferencesPage = lazy(() =>
  import("../views/settings/app-preferences/AppPreferencesPage").then((m) => ({
    default: m.AppPreferencesPage,
  })),
);

export const FieldsPage = lazy(() =>
  import("../views/settings/fields/FieldsPage").then((m) => ({
    default: m.FieldsPage,
  })),
);

// Tickets (cross-portal view)
const AllTicketsPage = lazy(() =>
  import("../views/portals/AllTicketsPage").then((module) => ({
    default: module.AllTicketsPage,
  })),
);

// Portals (project management)
export const CreatePortalPage = lazy(() =>
  import("../views/portals/CreatePortalPage").then((m) => ({
    default: m.CreatePortalPage,
  })),
);

export const AllPortalsPage = lazy(() =>
  import("../views/portals/AllPortalsPage").then((module) => ({
    default: module.AllPortalsPage,
  })),
);

export const PortalsDashboardPage = lazy(() =>
  import("../views/portals/PortalsDashboardPage").then((module) => ({
    default: module.PortalsDashboardPage,
  })),
);

export const PortalBoardView = lazy(() =>
  import("../views/portals/board/PortalBoardView").then((module) => ({
    default: module.PortalBoardView,
  })),
);

export const PortalListView = lazy(() =>
  import("../views/portals/list/PortalListView").then((module) => ({
    default: module.PortalListView,
  })),
);

export const PortalCalendarView = lazy(() =>
  import("../views/portals/calendar/PortalCalendarView").then((module) => ({
    default: module.PortalCalendarView,
  })),
);

export const WorkItemDetailPage = lazy(() =>
  import("../components/routing/GuardedWorkItemDetailPage").then((module) => ({
    default: module.GuardedWorkItemDetailPage,
  })),
);

export const CreateWorkItemPage = lazy(() =>
  import("../views/portals/CreateWorkItemPage").then((module) => ({
    default: module.CreateWorkItemPage,
  })),
);

export const PortalSettingsPage = lazy(() =>
  import("../views/portals/settings/PortalSettingsPage").then((module) => ({
    default: module.PortalSettingsPage,
  })),
);

export const PortalSettingsAccessPage = lazy(() =>
  import("../views/portals/settings/AccessPage").then((module) => ({
    default: module.AccessPage,
  })),
);

export const ServiceDeskPage = lazy(() =>
  import("../views/portals/settings/ServiceDeskPage").then((module) => ({
    default: module.ServiceDeskPage,
  })),
);

export const RequestTypeDetailPage = lazy(() =>
  import("../views/portals/settings/RequestTypeDetailPage").then((m) => ({
    default: m.RequestTypeDetailPage,
  })),
);

export const WorkflowEditorPage = lazy(() =>
  import("../views/portals/settings/WorkflowEditor").then((module) => ({
    default: module.WorkflowEditor,
  })),
);

export const AgentGroupsPage = lazy(() =>
  import("../views/portals/settings/AgentGroupsPage").then((module) => ({
    default: module.AgentGroupsPage,
  })),
);

export const QueuesSettingsPage = lazy(() =>
  import("../views/portals/settings/QueuesPage").then((module) => ({
    default: module.QueuesPage,
  })),
);

export const PortalEmailSettingsPage = lazy(() =>
  import("../views/portals/settings/PortalEmailSettingsPage").then((m) => ({
    default: m.PortalEmailSettingsPage,
  })),
);

export const AssignmentMatrixPage = lazy(() =>
  import("../views/portals/settings/AssignmentMatrixPage").then((m) => ({
    default: m.AssignmentMatrixPage,
  })),
);

export const CustomFieldsPage = lazy(() =>
  import("../views/portals/settings/CustomFieldsPage").then((m) => ({
    default: m.CustomFieldsPage,
  })),
);

export const FormBuilderPage = lazy(() =>
  import("../views/portals/settings/FormBuilderPage").then((m) => ({
    default: m.FormBuilderPage,
  })),
);

export const ArchivedTicketsPage = lazy(() =>
  import("../views/portals/settings/ArchivedTicketsPage").then((m) => ({
    default: m.ArchivedTicketsPage,
  })),
);

export const BinPage = lazy(() =>
  import("../views/portals/settings/BinPage").then((m) => ({
    default: m.BinPage,
  })),
);

export const FormFillPage = lazy(() =>
  import("../views/forms/FormFillPage").then((m) => ({
    default: m.FormFillPage,
  })),
);

export const SLAPoliciesPage = lazy(() =>
  import("../views/portals/settings/SLAPoliciesPage").then((m) => ({
    default: m.SLAPoliciesPage,
  })),
);

export const RecurringTicketsPage = lazy(() =>
  import("../views/portals/settings/RecurringTicketsPage").then((m) => ({
    default: m.RecurringTicketsPage,
  })),
);

export const ScheduledReportsPage = lazy(() =>
  import("../views/portals/settings/ScheduledReportsPage").then((m) => ({
    default: m.ScheduledReportsPage,
  })),
);

export const BusinessHoursPage = lazy(() =>
  import("../views/portals/settings/BusinessHoursPage").then((m) => ({
    default: m.BusinessHoursPage,
  })),
);

export const AutomationsPage = lazy(() =>
  import("../views/portals/settings/AutomationsPage").then((m) => ({
    default: m.AutomationsPage,
  })),
);

export const AutomationRuleEditor = lazy(() =>
  import("../views/portals/settings/AutomationRuleEditor").then((m) => ({
    default: m.AutomationRuleEditor,
  })),
);

export const MacrosPage = lazy(() =>
  import("../views/portals/settings/MacrosPage").then((m) => ({
    default: m.MacrosPage,
  })),
);

export const KnowledgeBasePage = lazy(() =>
  import("../views/portals/settings/KnowledgeBasePage").then((m) => ({
    default: m.KnowledgeBasePage,
  })),
);

export const KbArticleEditorPage = lazy(() =>
  import("../views/portals/settings/KbArticleEditorPage").then((m) => ({
    default: m.KbArticleEditorPage,
  })),
);

export const CsatSettingsPage = lazy(() =>
  import("../views/portals/settings/CsatSettingsPage").then((m) => ({
    default: m.CsatSettingsPage,
  })),
);

export const NpsSettingsPage = lazy(() =>
  import("../views/portals/settings/NpsSettingsPage").then((m) => ({
    default: m.NpsSettingsPage,
  })),
);

export const IntegrationsPage = lazy(() =>
  import("../views/portals/settings/IntegrationsPage").then((m) => ({
    default: m.IntegrationsPage,
  })),
);

export const DataSyncPage = lazy(() =>
  import("../views/portals/settings/DataSyncPage").then((m) => ({
    default: m.DataSyncPage,
  })),
);

export const HubSpotConfigPage = lazy(() =>
  import("../views/portals/settings/HubSpotConfigPage").then((m) => ({
    default: m.HubSpotConfigPage,
  })),
);

export const SharePointConfigPage = lazy(() =>
  import("../views/portals/settings/SharePointConfigPage").then((m) => ({
    default: m.SharePointConfigPage,
  })),
);

export const InboxPage = lazy(() =>
  import("../views/portals/InboxPage").then((m) => ({
    default: m.InboxPage,
  })),
);

export const PortalQueueView = lazy(() =>
  import("../views/portals/PortalQueueView").then((module) => ({
    default: module.PortalQueueView,
  })),
);

// Reports
export const ReportsPage = lazy(() =>
  import("../views/portals/reports/ReportsPage").then((m) => ({
    default: m.ReportsPage,
  })),
);

export const CreatedVsResolvedReport = lazy(() =>
  import("../views/portals/reports/CreatedVsResolvedReport").then((m) => ({
    default: m.CreatedVsResolvedReport,
  })),
);

export const SLAComplianceReport = lazy(() =>
  import("../views/portals/reports/SLAComplianceReport").then((m) => ({
    default: m.SLAComplianceReport,
  })),
);

export const AgentPerformanceReport = lazy(() =>
  import("../views/portals/reports/AgentPerformanceReport").then((m) => ({
    default: m.AgentPerformanceReport,
  })),
);

export const RequestTypeReport = lazy(() =>
  import("../views/portals/reports/RequestTypeReport").then((m) => ({
    default: m.RequestTypeReport,
  })),
);

export const ResolutionTimeReport = lazy(() =>
  import("../views/portals/reports/ResolutionTimeReport").then((m) => ({
    default: m.ResolutionTimeReport,
  })),
);

export const CsatReport = lazy(() =>
  import("../views/portals/reports/CsatReport").then((m) => ({
    default: m.CsatReport,
  })),
);

export const ReportBuilderPage = lazy(() =>
  import("../views/portals/reports/ReportBuilderPage").then((m) => ({
    default: m.ReportBuilderPage,
  })),
);

export const CustomReportsSettingsPage = lazy(() =>
  import("../views/portals/settings/CustomReportsSettingsPage").then((m) => ({
    default: m.CustomReportsSettingsPage,
  })),
);

export const NpsReport = lazy(() =>
  import("../views/portals/reports/NpsReport").then((m) => ({
    default: m.NpsReport,
  })),
);

export const CustomReportPage = lazy(() =>
  import("../views/portals/reports/CustomReportPage").then((m) => ({
    default: m.CustomReportPage,
  })),
);

// Customer portal settings (admin-facing)
export const CustomerPortalSettingsPage = lazy(() =>
  import("../views/customer/CustomerPortalSettingsPage").then((m) => ({
    default: m.CustomerPortalSettingsPage,
  })),
);

// User manual
export const UserManualPage = lazy(() =>
  import("../views/settings/user-manual/UserManualPage").then((m) => ({
    default: m.UserManualPage,
  })),
);

// Customer portal pages (end-user facing)
export const CustomerPortalsPage = lazy(() =>
  import("../views/customer/CustomerPortalsPage").then((module) => ({
    default: module.CustomerPortalsPage,
  })),
);

export const CustomerPortalDetailPage = lazy(() =>
  import("../views/customer/CustomerPortalDetailPage").then((module) => ({
    default: module.CustomerPortalDetailPage,
  })),
);

export const CustomerMyRequestsPage = lazy(() =>
  import("../views/customer/CustomerMyRequestsPage").then((m) => ({
    default: m.CustomerMyRequestsPage,
  })),
);

export const CustomerRequestDetailPage = lazy(() =>
  import("../views/customer/CustomerRequestDetailPage").then((m) => ({
    default: m.CustomerRequestDetailPage,
  })),
);

export const CustomerKnowledgeBasePage = lazy(() =>
  import("../views/customer/CustomerKnowledgeBasePage").then((m) => ({
    default: m.CustomerKnowledgeBasePage,
  })),
);

// Employee self-service workspace (5a) — end-user facing.
export const EmployeeWorkspacePage = lazy(() =>
  import("../views/customer/EmployeeWorkspacePage").then((m) => ({
    default: m.EmployeeWorkspacePage,
  })),
);

export const ManagerHubPage = lazy(() =>
  import("../views/customer/ManagerHubPage").then((m) => ({
    default: m.ManagerHubPage,
  })),
);

export const MyOrgPage = lazy(() =>
  import("../views/customer/MyOrgPage").then((m) => ({
    default: m.MyOrgPage,
  })),
);

// Public pages (no auth)
const SurveyPage = lazy(() =>
  import("../views/public/SurveyPage").then((m) => ({
    default: m.SurveyPage,
  })),
);

// People
export const ContactsPage = lazy(() =>
  import("../views/contacts/ContactsPage").then((m) => ({
    default: m.ContactsPage,
  })),
);

export const ContactDetailPage = lazy(() =>
  import("../views/contacts/ContactDetailPage").then((m) => ({
    default: m.ContactDetailPage,
  })),
);

export const OrganizationsPage = lazy(() =>
  import("../views/organizations/OrganizationsPage").then((m) => ({
    default: m.OrganizationsPage,
  })),
);

export const OrgDetailPage = lazy(() =>
  import("../views/organizations/OrgDetailPage").then((m) => ({
    default: m.OrgDetailPage,
  })),
);

// AI Playground
export const AiPlaygroundPage = lazy(() =>
  import("../views/portals/AiPlaygroundPage").then((m) => ({
    default: m.AiPlaygroundPage,
  })),
);

export const AiAgentSettingsPage = lazy(() =>
  import("../views/portals/settings/AiAgentSettingsPage").then((m) => ({
    default: m.AiAgentSettingsPage,
  })),
);

export const SkyAgentWorkspacePage = lazy(() =>
  import("../views/skyagent/SkyAgentWorkspace").then((m) => ({
    default: m.SkyAgentWorkspace,
  })),
);

// Each sub-page is served inside the shared workspace rail (see shelled.tsx);
// only the chat owns its own sidebar, because it also lists conversations.
// skyBrain is its own surface with its own rail — the same shell, a different
// nav — rather than a guest inside the skyAgent workspace.
// /skybrain itself redirects to Memory, whose first tab is the Overview.
export const SkyBrainRootPage = lazy(() =>
  import("../views/skyagent/SkyBrainRoot").then((m) => ({ default: m.SkyBrainRoot })),
);

export const SkyBrainIndexPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainIndex })),
);

export const SkyBrainSettingsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainSettings })),
);

export const SkyBrainSystemPromptPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainSystemPrompt })),
);

export const SkyBrainMemoryPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainMemory })),
);

export const SkyBrainSkillsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainSkills })),
);

export const SkyBrainIntegrationsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyBrainIntegrations })),
);

export const SkyAgentProjectsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyAgentProjects })),
);
export const SkyAgentArtifactsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyAgentArtifacts })),
);
export const SkyAgentSchedulesPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyAgentSchedules })),
);
export const SkyAgentSkillsPage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyAgentSkills })),
);
/**
 * Rendered WITHOUT the skyAgent workspace rail.
 *
 * Configuration is reached from the app's own sidebar, not from inside the
 * workspace, so wrapping it in the rail would put a second nav inside the one
 * that got you there.
 */
export const SkyAgentConfigurationPage = lazy(() =>
  import("../views/skyagent/SkyAgentConfiguration").then((m) => ({
    default: m.SkyAgentConfiguration,
  })),
);

export const SkyAgentCustomizePage = lazy(() =>
  import("../views/skyagent/shelled").then((m) => ({ default: m.ShelledSkyAgentCustomize })),
);
